/**
 * Editorial Calendar — types + API + view
 *
 * Sprint 6 · Project Symphony. Deterministic. Read-only from the
 * server's perspective (except for approve).
 */
import { http } from "@/shared/api/http";

export interface EditorialSlot {
  slot_id: string;
  task_id: string;
  generated_asset_id: string | null;
  content_type: string;
  channel: string;
  channel_label: string;
  theme: string;
  theme_label: string;
  publish_at: string;
  day_label: string;
  advice: string;
  reason: string;
  locked: boolean;
}

export interface EditorialHealth {
  score: number;
  label: string;
  indicator: string;
  campaign_balance_pct: number;
  audience_fatigue: string;
  coverage_pct: number;
  theme_count: number;
  slot_count: number;
}

export interface EditorialConflict {
  kind: string;
  severity: "high" | "medium" | "low";
  message: string;
}

export interface EditorialSchedule {
  workspace_id: string;
  campaign_id: string;
  status: "proposed" | "approved";
  slots: EditorialSlot[];
  conflicts: EditorialConflict[];
  editorial_health: EditorialHealth;
  start_date: string;
  end_date: string;
  approved_at: string | null;
}

export const getEditorial = (id: string): Promise<EditorialSchedule> =>
  http<EditorialSchedule>(`/orchestration/blueprints/${id}/editorial`);

export const planEditorial = (id: string): Promise<EditorialSchedule> =>
  http<EditorialSchedule>(`/orchestration/blueprints/${id}/editorial/plan`, { method: "POST" });

export const approveEditorial = (id: string): Promise<EditorialSchedule> =>
  http<EditorialSchedule>(`/orchestration/blueprints/${id}/editorial/approve`, { method: "POST" });
